import type { UrbanNetworkEdge } from './api';

const SIN_DATO = 'Sin dato';

function fmtStr(v: string | null): string {
  return v && v.length > 0 ? v : SIN_DATO;
}

function fmtNum(v: number | null, decimals = 0, suffix = ''): string {
  return v === null ? SIN_DATO : `${v.toFixed(decimals)}${suffix}`;
}

function fmtBool(v: boolean | null): string {
  if (v === null) return SIN_DATO;
  return v ? 'Sí' : 'No';
}

/**
 * Panel de inspección de UN canonical edge, cuando se hace click sobre la
 * capa "Red urbana" SIN ninguna parada seleccionada — puramente de
 * lectura, nunca ofrece "editar"/"aplicar". `canonical_edges` no tiene
 * columna de nombre de calle: `sourceReference`/`routeRef` son la única
 * referencia textual disponible, nunca se inventa un nombre.
 */
export function SystemMapEdgePanel({
  edge,
  onClose,
}: {
  edge: UrbanNetworkEdge;
  onClose: () => void;
}): JSX.Element {
  return (
    <div className="smap-detail-panel smap-detail-panel--open">
      <div className="smap-detail-inner">
        <div className="smap-detail-header">
          <div>
            <p className="smap-detail-title">Segmento de red</p>
            <p className="smap-detail-sub">canonical edge</p>
          </div>
          <button type="button" className="smap-detail-close" onClick={onClose} aria-label="Cerrar">
            ✕
          </button>
        </div>

        <div className="smap-detail-section">
          <p className="smap-detail-section-title">Identificación</p>
          <div className="smap-detail-row">
            <span className="smap-detail-row-label">Canonical edge</span>
            <span className="smap-detail-row-value">{edge.id}</span>
          </div>
          <div className="smap-detail-row">
            <span className="smap-detail-row-label">Referencia</span>
            <span className="smap-detail-row-value">{fmtStr(edge.sourceReference)}</span>
          </div>
          <div className="smap-detail-row">
            <span className="smap-detail-row-label">Route ref</span>
            <span className="smap-detail-row-value">{fmtStr(edge.routeRef)}</span>
          </div>
          <div className="smap-detail-row">
            <span className="smap-detail-row-label">Clase de vía</span>
            <span className="smap-detail-row-value">{fmtStr(edge.roadClass)}</span>
          </div>
        </div>

        <div className="smap-detail-section">
          <p className="smap-detail-section-title">Geometría</p>
          <div className="smap-detail-row">
            <span className="smap-detail-row-label">Longitud</span>
            <span className="smap-detail-row-value">{fmtNum(edge.lengthMeters, 1, ' m')}</span>
          </div>
          <div className="smap-detail-row">
            <span className="smap-detail-row-label">Sentido único</span>
            <span className="smap-detail-row-value">{fmtBool(edge.oneway)}</span>
          </div>
          {edge.oneway && (
            <div className="smap-detail-row">
              <span className="smap-detail-row-label">Dirección</span>
              <span className="smap-detail-row-value">{fmtStr(edge.onewayDirection)}</span>
            </div>
          )}
          <div className="smap-detail-row">
            <span className="smap-detail-row-label">Nodo origen</span>
            <span className="smap-detail-row-value">{edge.fromNodeId}</span>
          </div>
          <div className="smap-detail-row">
            <span className="smap-detail-row-label">Nodo destino</span>
            <span className="smap-detail-row-value">{edge.toNodeId}</span>
          </div>
        </div>

        <p className="smap-advanced-note">
          Servicio de transporte y líneas asociadas — ver rutas resaltadas en el mapa si este
          segmento coincide con algún corredor servido.
        </p>
      </div>
    </div>
  );
}
